// @ts-nocheck
import React from 'react';
import axios from "axios";
import {
    Box, Typography, Divider, Modal, Grid, IconButton,
    InputAdornment, Paper, Stack, useMediaQuery
} from "@mui/material";
import { Add, Remove, Close } from "@mui/icons-material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import CircularIndeterminate from "../../Componentes/CircularIndeterminate";
import FormInput from "../../Componentes/FormInput";
import SinapThemev2 from "../../styles/SinapThemev2";
import { useUsuarios } from "../State/UsuarioContext";
import { useAuth } from "../../Auth/State/AuthContext";
import { useBody } from "../../Body/state/BodyContext";
import { RUTA_API_ALIAS } from "../../Contantes/Constantes";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 380,
    maxHeight: '70vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

export default function ModalAliasDeUsuario({ prev, open, onClose }) {
    const { setSuccess, setMessage } = useBody();
    const matches = useMediaQuery('(max-width:600px)');
    const { aliasDirectos, aliasIndirectos, getAliasDeUsuario } = useUsuarios();
    const { user } = useAuth();
    const [loading, setLoading] = React.useState(false);
    const [newAlias, setNewAlias] = React.useState("");
    const axiosInstance = setupInterceptorsTo(axios.create());

    const handleClickAddAlias = async (index, action, alias) => {
        if (!alias) return;
        if (action === "remove") await handleDelete(index, alias);
        else await handleAdd(index, alias);
    };

    const handleDelete = async (index, alias) => {
        try {
            await axiosInstance.put(`${RUTA_API_ALIAS}/user/${prev.uid}/quitar/${alias}`);
            setSuccess('Se quitó el usuario al alias con éxito');
            getAliasDeUsuario(prev.uid);
            setNewAlias("");
        } catch (error) {
            setMessage('Error al quitar el usuario del alias (Código: 00051)');
        }
    };

    const handleAdd = async (index, alias) => {
        try {
            await axiosInstance.put(`${RUTA_API_ALIAS}/user/${prev.uid}/anadir/${alias}`);
            setSuccess('Se añadió el usuario al alias con éxito');
            getAliasDeUsuario(prev.uid);
            setNewAlias("");
        } catch (error) {
            setMessage('Error al añadir el usuario al alias (Código: 00050)');
        }
    };

    React.useEffect(() => {
        if (prev?.uid) getAliasDeUsuario(prev.uid);
    }, [prev]);

    return (
        <Modal keepMounted open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>

                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={SinapThemev2}>
                        {loading ? (
                            <Grid container justifyContent="center" alignItems="center">
                                <CircularIndeterminate />
                            </Grid>
                        ) : (
                            <Stack spacing={3}>
                                <Typography variant={matches ? "h5" : "h4"} color="primary">
                                    Datos del Usuario
                                </Typography>
                                <Divider />
                                <Paper variant="outlined" sx={{ p: 2 }}>
                                    <Stack spacing={1}>
                                        <Typography variant="body1">Apellido: {prev.apellido}</Typography>
                                        <Typography variant="body1">Nombre: {prev.nombre}</Typography>
                                        <Typography variant="body1">Usuario: {prev.uid}</Typography>
                                        <Typography variant="body1">Mail FRBA: {prev.frbaEmail}</Typography>
                                        <Typography variant="body1">Mail alternativo: {prev.personalEmail}</Typography>
                                    </Stack>
                                </Paper>

                                <Box>
                                    <Typography variant="h6" color="primary">Alias directos</Typography>
                                    <Divider sx={{ my: 1 }} />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <FormInput
                                                name="Alias"
                                                label="Nuevo alias"
                                                value={newAlias}
                                                onChange={(e) => setNewAlias(e.target.value)}
                                                onKeyPress={(e) => e.key === 'Enter' && handleClickAddAlias(0, "add", newAlias)}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={() => handleClickAddAlias(0, "add", newAlias)} size="large">
                                                                <Add />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                disabled={loading}
                                            />
                                        </Grid>

                                        {aliasDirectos.length > 0 ? aliasDirectos.map((alias, index) => (
                                            <Grid item xs={12} key={index}>
                                                <FormInput
                                                    label={`Alias ${index + 1}`}
                                                    value={alias}
                                                    disabled
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={() => handleClickAddAlias(index, "remove", alias)} size="large">
                                                                    <Remove />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </Grid>
                                        )) : (
                                            <Grid item xs={12}>
                                                <Typography variant="body2" color="textSecondary">
                                                    No hay alias directos asignados.
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>

                                <Box>
                                    <Typography variant="h6" color="primary">Alias indirectos</Typography>
                                    <Divider sx={{ my: 1 }} />
                                    <Stack spacing={1}>
                                        {aliasIndirectos.length > 0 ? aliasIndirectos.map((alias, i) => (
                                            <Typography key={i} variant="body2">{alias}</Typography>
                                        )) : (
                                            <Typography variant="body2" color="textSecondary">
                                                No hay alias indirectos disponibles.
                                            </Typography>
                                        )}
                                    </Stack>
                                </Box>
                            </Stack>
                        )}
                    </ThemeProvider>
                </StyledEngineProvider>
            </Box>
        </Modal>
    );
}
